import { render, staticRenderFns } from "./TagsTable.vue?vue&type=template&id=493b106f&scoped=true"
import script from "./TagsTable.vue?vue&type=script&lang=js"
export * from "./TagsTable.vue?vue&type=script&lang=js"
import style0 from "./TagsTable.vue?vue&type=style&index=0&id=493b106f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b106f",
  null
  
)

export default component.exports